class MegaMenuImageHover {
  constructor(container) {
    this.container = container;
    this.imageContainer = container.querySelector('.megamenu-image-card__container');
    this.links = container.querySelectorAll('[data-hover-image]');
    this.images = container.querySelectorAll('.megamenu-image-card__item');
    this.defaultImage = container.querySelector('.megamenu-image-card__item[data-default="true"]');

    if (!this.imageContainer || !this.links.length) return;

    this.init();
  }

  init() {
    this.links.forEach(link => {
      link.addEventListener('mouseenter', () => this.showImage(link));
      link.addEventListener('focus', () => this.showImage(link));
    });

    this.container.addEventListener('mouseleave', () => this.resetImage());
  }

  showImage(link) {
    const imageId = link.getAttribute('data-hover-image');
    const targetImage = this.container.querySelector(`.megamenu-image-card__item[data-image-id="${imageId}"]`);
    if (!targetImage) return;

    this.images.forEach(img => img.classList.remove('active'));
    this.links.forEach(l => l.classList.remove('is-hovered'));

    targetImage.classList.add('active');
    link.classList.add('is-hovered');
  }

  resetImage() {
    if (!this.defaultImage) return;

    this.images.forEach(img => img.classList.remove('active'));
    this.links.forEach(l => l.classList.remove('is-hovered'));
    this.defaultImage.classList.add('active');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.megamenu-stanley').forEach(menu => new MegaMenuImageHover(menu));
});

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.megamenu-stanley').forEach(menu => new MegaMenuImageHover(menu));
  });
}

(function() {
  const triggers = document.querySelectorAll('li.has-megamenu.megamenu-stanley');
  if (!triggers.length) return;

  triggers.forEach(trigger => {
    let closeTimer = null;
    const CLOSE_DELAY = 300;
    const panel = trigger.querySelector('ul');

    function openMenu() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      trigger.classList.add('mega-is-open');
    }

    function scheduleClose() {
      closeTimer = setTimeout(() => {
        trigger.classList.remove('mega-is-open');
      }, CLOSE_DELAY);
    }

    trigger.addEventListener('mouseenter', openMenu);
    trigger.addEventListener('mouseleave', (e) => {
      if (trigger.contains(e.relatedTarget)) return;
      scheduleClose();
    });

    if (panel) {
      panel.addEventListener('mouseenter', openMenu);
      panel.addEventListener('mouseleave', (e) => {
        if (trigger.contains(e.relatedTarget)) return;
        scheduleClose();
      });
    }
  });
})();